import React,{useState,useEffect} from 'react'
import {Container,Row,Col,Card,Button,Form} from "react-bootstrap";
import PageTitle from "../components/common/PageTitle";
import api from '../api/api'
import  Html5QrcodePlugin  from "../views/Html5QrcodePlugin";
import { useTranslation } from "react-i18next";
import swal from 'sweetalert';
import './AdminManagement.css';

const AddEquipmentByAdmin = () => {
    const { t } = useTranslation();

    const [resultScan,setResultScan] = useState('')
    const [name,setName] = useState('')
    const [description, setDescription] = useState('')

    const [codeError, setcodeErr] = useState("");

    const onNewScanResult = (decodedText, decodedResult) => {
      setResultScan(decodedText)

      // Handle the result here.
    }

      const isValidate = () => {
        let codeErr = ''
        if (!resultScan || resultScan === '') {
            codeErr = t('cannot_be_blank')
            setcodeErr(codeErr)
            return false
        }
        setcodeErr('')
        return true
    }

    const submitEquipment = () => {
        let isValid = isValidate()
        if (isValid) {
          addNewEquipment()
        }
    }

    const addNewEquipment = () =>{
      let data = {
            name :name,
           code :resultScan,
           description: description,
       }
       api.post('/admin/add-equipment',data)
       .then( response =>  {
         if(response.data.type === 'success'){
           swal(`${t("equipment_added")}`, {
               icon: "success",
           })
           resetForm()
       }
       }).catch(err =>{
         console.error(err)
         swal({
           icon: 'error',
           title: t('Oops...'),
           text: t('error')
       })
       })
     }

     const resetForm = () => {
      setResultScan('')
      setName('')
      setDescription('')
      setcodeErr('')
  }



  return (
    <>
    <Container fluid className="admin-management-page">
    <Row noGutters className="admin-management-heading">
      <PageTitle
        sm="4"
        title={t('Add_Equipment')}
        subtitle={t('Add_Equipment')}
        className="text-sm-left"
      />
    </Row>

    <Row>
      <Col lg="12" md="8" sm="12" className="mb-4">
        <Card small className="h-100 admin-data-card">
          <Card.Header className="border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
            <h6 className="m-0">{t('Equipment_setup')}</h6>
            <div className="admin-management-actions">
              <Button
                variant="success"
                onClick={() => submitEquipment()}
              >
                <i className="fa fa-check mx-2"></i>
                {t('save')}
              </Button>
              <Button
                variant="outline-primary"
                onClick={resetForm}
              >
                <i className="fa fa-times mx-2"></i>
                {t('cancel')}
              </Button>
            </div>
          </Card.Header>
          <Card.Body className="pt-0">
            <div
              style={{
                display: "flex",
                marginTop: "20px",
                flexWrap: "wrap",
                gap:"20px"
              }}
            >
              <Col lg="5" sm="12" md="6">
                <Form>
                  <Row form className='gap-4'>
                  <Col lg="5" md="12" sm="12" className="form-group">
                  <p style={{ margin: "0px" }}>{t('Equipment_name')}</p>
                      <Form.Control
                            placeholder={t('Equipment_name')}
                            required
                            value={name}
                            onChange={(e)=> setName(e.target.value)}
                          />
                    </Col>
                    <Col md="6" className="form-group">
                      <p style={{ margin: "0px" }}>{t('Equipment_code')}</p>
                      <Form.Control
                            placeholder={t('Equipment_code')}
                            required
                            value={resultScan}
                            onChange={(e)=> setResultScan(e.target.value)}
                            className={`form-control ${codeError ? 'is-invalid' : ""}`}

                          />
                           <div className="invalid-feedback">{codeError}</div>

                    </Col>
                  </Row>
                  <Form.Group>
                    <p style={{ margin: "0px" }}>{t('desc')}</p>
                    <textarea
                      style={{ height: "220px" }}
                      className="form-control"
                      placeholder={t('desc')}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                  </Form.Group>
                </Form>
              </Col>
              <Col lg="6" md="12" sm="12" className="mb-4">
              <div>
            <h3>{t('scan_qrcode_Equipment')}</h3>
                <Html5QrcodePlugin 
                  fps={10}
                  qrbox={250}
                  disableFlip={true}
                  rememberLastUsedCamera={false}
                  qrCodeSuccessCallback={onNewScanResult}

                  />
              </div>
              </Col>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>
    
    </>
  )
}

export default AddEquipmentByAdmin